export function normalizeFulfillmentMode(mode = "") {
  return String(mode || "").trim().toLowerCase() === "delivery" ? "delivery" : "pickup";
}

// A fulfilment assignment is authoritative as soon as its own row identifies
// both the fulfilment and the selected Pharmacy owner. Display-profile reads
// enrich this relationship; they never create or invalidate it.
export function hasCanonicalPharmacyAssignment(fulfillment = {}) {
  return Boolean(
    String(fulfillment?.id || "").trim() && String(fulfillment?.pharmacyId || "").trim(),
  );
}

export function resolveCanonicalFulfillmentState({ status = "", mode = "" } = {}) {
  const normalizedStatus = String(status || "").trim().toLowerCase();
  const normalizedMode = normalizeFulfillmentMode(mode);
  const ready = ["ready_for_pickup", "ready_for_delivery"].includes(normalizedStatus);

  return {
    status: normalizedStatus,
    mode: normalizedMode,
    ready,
    patientLabel: ready
      ? normalizedMode === "delivery"
        ? "Ready for delivery"
        : "Ready for pickup"
      : "",
  };
}
